import ExitIcon from "assets/icon/ExitIcon"

export default function LogoutButton(props){
    return(
        <button className='flex gap-2 sm:px-4 py-2 hover' onClick={props?.onClick}>
            <span className="hidden sm:block">Logout</span>
            <ExitIcon />
        </button>
    )
}